import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme as themeConfig } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  .MuiTextField-root {
    margin-right: 1em;
  }
  .MuiIconButton-colorInherit {
    border-radius: 0px;
    margin-right: 0px;
    padding: 0px;
    height: 1.7em;
  }
  .MuiIcon-colorPrimary {
    color: ${({ theme }) => theme.tabs.selected} !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: none;
  }
  .MuiIcon-colorSecondary {
    color: ${({ theme }) => theme.neutral.gray[400]} !important;
    border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
    width: 1.7em;
    height: 1.7em;
    font-size: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
    z-index: 1 !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  .MuiFormControlLabel-root {
    margin-right: 0px;
  }
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[1200],
    },
  },
}));
